window.vimeo = {
    $vimeoWrappers: null,

    init: function() {
        this.$vimeoWrappers = document.querySelectorAll(".prettyembed--wrapper");

        this.$vimeoWrappers.forEach(function (item){
            item.addEventListener('click', function (){
                window.vimeo.matomoDOMElementRescan(item);
            });
        });
    },

    /**
     * Rescanning an DOM Element for Matomo Tracking after Event Trigger
     * @param updatedElement
     */
    matomoDOMElementRescan: function (updatedElement) {
        document.addEventListener('prettyembed', function () {
            _paq.push(['MediaAnalytics::scanForMedia']);
        });
    }
}
